import RecaptchaInitializerBase from "./RecaptchaInitializerBase";

declare const gRecaptchaSiteKey: any; // use type 'any' to work around named elements being used as 'document' properties
declare const grecaptcha: any;
export default class RecaptchaV3Initializer extends RecaptchaInitializerBase {

    public static init(jq: JQueryStatic, action: string, callback: (token: string) => any): void {
        if (typeof grecaptcha !== "undefined") {
            let siteKey: string;
            if (typeof gRecaptchaSiteKey === "string" && gRecaptchaSiteKey) {
                siteKey = gRecaptchaSiteKey;
            } else {
                siteKey = jq("#gRecaptchaSiteKey").val() as string;
            }
            grecaptcha.execute(siteKey, {action}).then(callback);
        } else {
            callback(null);
        }
    }

}
